export default "__VITE_ASSET__DpxohKT0__"